// extracted by mini-css-extract-plugin
export default {"wrapper":"PaginatedTable_wrapper__JSTwp","footerValues":"PaginatedTable_footerValues__skBzd"};